import PropTypes from 'prop-types';

// Outline brand icons (Lucide-style paths) so they match the Heroicons outline look.
const ICONS = {
  Instagram: (
    <>
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
    </>
  ),
  Facebook: (
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
  ),
};

function SocialIcon({ name, className = 'h-5 w-5' }) {
  const paths = ICONS[name];
  if (!paths) return null;
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {paths}
    </svg>
  );
}

SocialIcon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
};

SocialIcon.defaultProps = {
  className: 'h-5 w-5',
};

export default SocialIcon;
